import React, { useEffect, useState } from 'react';
import HeaderRec from '../../header/headerRec';
import axios from 'axios';
import Pagination from '../../commun/Pagination';
import { useNavigate } from 'react-router-dom';
import { showDeleteConfirmation } from '../../commun/deletemsg';
import GenericTable from '../../commun/GenericTable';
import ActionButtons from '../../commun/ActionButtons';
import AjouterTalentModal from '../../commun/AddTalentModal';
import {
  Button, Typography, Box, TextField
} from '@mui/material';
import Chatbox from '../../commun/ChatBox';
import { statusColorMapRecruteur } from '../../commun/constants/options';
import StatusTabs from '../../commun/StatusTabs';
import Footer from '../../commun/Footer';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import './mesTalents.css';

const MesTalents = () => {
  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [talents, setTalents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredStatus, setFilteredStatus] = useState(null);
  const [grouped, setGrouped] = useState({});
  const [page, setPage] = useState(1);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [displayMode, setDisplayMode] = useState('table');

  const talentsPerPage = 8;
  const navigate = useNavigate();

  useEffect(() => {
    fetchTalents();
  }, [userId, API_BASE]);

  const fetchTalents = () => {
    axios
      .get(`${API_BASE}/api/recruteur/get-talents`, {
        params: { recruteurId: userId },
      })
      .then((res) => setTalents(res.data))
      .catch((err) => console.error('Erreur récupération talents:', err));
  };

  useEffect(() => {
    const group = {};
    talents.forEach((t) => {
      const stat = t.statut || 'Non défini';
      if (!group[stat]) group[stat] = [];
      group[stat].push(t);
    });
    setGrouped(group);
  }, [talents]);

  useEffect(() => {
    setPage(1);
  }, [filteredStatus, searchTerm]);

  const filteredTalents = (filteredStatus ? grouped[filteredStatus] || [] : talents).filter(t => {
    const matchesEmail = Array.isArray(t.email)
      ? t.email.some(email => email.toLowerCase().includes(searchTerm.toLowerCase()))
      : false;
    const matchesName = (
      t.nomCandidat?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.prenomCandidat?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return matchesEmail || matchesName;
  });

  const isValidDate = (value) => {
    const date = new Date(value);
    return !isNaN(date.getTime());
  };

  const formatPhone = (value) => {
    if (!value) return 'Non renseigné';
    const phones = Array.isArray(value) ? value : [value];
  
    return phones.map((num) => {
      try {
        const cleaned = num.replace(/\s|\./g, '');
        const phoneNumber = parsePhoneNumberFromString(cleaned, 'FR'); 
        return phoneNumber ? phoneNumber.formatInternational() : num;
      } catch {
        return num;
      }
    }).join(', ');
  };
  
  const columns = [
    { key: 'nomCandidat', label: 'Nom' },
    { key: 'prenomCandidat', label: 'Prénom' },
    {
      key: 'email', label: 'Email',
      render: (value) => Array.isArray(value) ? value.join(', ') : value
    },
    {
      key: 'phone',
      label: 'Téléphone',
      render: (value) => formatPhone(value)
    },    
    {
      key: 'disponibilite', label: 'Disponibilité',
      render: (value) =>
        !value || value === 'null' || value.trim() === ''
          ? 'Non renseigné'
          : isValidDate(value)
            ? new Date(value).toLocaleDateString('fr-FR')
            : value,
    },
    {
      key: 'statut',
      label: 'Statut',
      render: (_, row) => {
        const rawStatus = row.statut || 'Non défini';
        const matched = statusColorMapRecruteur.find((s) => s.value === rawStatus);
        const displayLabel =
          rawStatus === "A traiter"
            ? "A qualifier"
            : matched?.label || rawStatus;
    
        return (
          <span className="status-badge" style={matched?.style}>
            {displayLabel}
          </span>
        );
      }
    }    
  ];

  return (
    <div>
      <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />

      <Box className="candidatContainer" p={3}>
        <Box className="headerTalentWrapper" display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5">Mes talents</Typography>
          <Button variant="contained" onClick={() => setOpenAddModal(true)}>Ajouter un talent</Button>
        </Box>

        <Box mt={3} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
          <TextField
            variant="outlined"
            label="Rechercher par nom, prénom ou email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="searchBarCompact"
          />

          <StatusTabs
            statuses={grouped}
            activeStatus={filteredStatus}
            onStatusChange={setFilteredStatus}
            userRole="recruteur"
            statusStylesSource={statusColorMapRecruteur}
          />
        </Box>

        <Box mt={3}>
          <GenericTable
            columns={columns}
            data={filteredTalents}
            selectedRows={selected}
            setSelectedRows={setSelected}
            itemsPerPage={talentsPerPage}
            currentPage={page}
            setPage={setPage}
            totalItems={filteredTalents.length}
            displayMode={displayMode}
            setDisplayMode={setDisplayMode}
            onDeleteSelected={(selectedIds) => {
            if (!selectedIds.length) return;
            showDeleteConfirmation({
            message: `Voulez-vous supprimer ${selectedIds.length} talent(s) sélectionné(s) ?`,
            onConfirm: async () => {
            try {
            // Suppression en parallèle
            await Promise.all(selectedIds.map(id =>
            fetch(`${API_BASE}/api/recruteur/delete-talents/${id}`, { method: 'DELETE' })
            ));
            setTalents(prev => prev.filter(t => !selectedIds.includes(t._id)));
            setSelected([]);
            } catch (err) {
            alert("Erreur lors de la suppression groupée.");
            }
            }
            });
            }}
            renderActions={(row) => (
              <ActionButtons
                showEdit={false}
                onView={() => navigate(`/Recruteur/talent-detail/${row._id}`)}
                onDelete={() => {
                  showDeleteConfirmation({
                    onConfirm: async () => {
                      try {
                        const res = await fetch(`${API_BASE}/api/recruteur/delete-talents/${row._id}`, { method: 'DELETE' });
                        if (res.ok) setTalents((prev) => prev.filter((t) => t._id !== row._id));
                        else alert('Échec suppression');
                      } catch (err) {
                        console.error(err);
                        alert('Erreur réseau');
                      }
                    },
                    onCancel: () => {},
                  });
                }}
                onDownload={row.cvUpload ? () => {
                  const link = document.createElement('a');
                  link.href = `${API_BASE}/api/recruteur/uploads/${row.cvUpload}`;
                  link.target = '_blank';
                  link.click();
                } : undefined}
                showDownload={!!row.cvUpload}
              />
            )}
          />

          {displayMode === 'table' && (
            <Pagination
              page={page}
              setPage={setPage}
              totalItems={filteredTalents.length}
              itemsPerPage={talentsPerPage}
            />
          )}
        </Box>

        <AjouterTalentModal
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}
          onSuccess={fetchTalents}
          onExtract={(file) => {
            navigate("/recruteur/add-talent", { state: { extractedFile: file } });
          }}
        />
      </Box>
      <Footer />
      <Chatbox userRole="recruteur" />
    </div>
  );
};

export default MesTalents;
